import {Directive, EventEmitter, Output} from '@angular/core';
import {ContextMenu} from './contextmenu';

@Directive({
    selector: '[contextMenu]'
})
export class ContextMenuDirective extends ContextMenu {
    @Output() onContextMenu = new EventEmitter<Event>();

    handle(event: Event): void {
        this.onContextMenu.emit(event);
    }
}
